package ld;

class GameState
{
	public var level: String;
	public var completedLevels: Int = 0;

	public static var instance(default, null):GameState = new GameState();

	public function new()
	{
		
	}
}